import { ClinicalVisualization } from "./components/ClinicalVisualization/ClinicalVisualization";
import { EditQuestionnaireContextProvider } from "../../contexts/EditQuestionnaireContext";
import { LargeContentBox } from "@/components/common";

export function MedicalCare() {
  return (
    <LargeContentBox>
      <EditQuestionnaireContextProvider>
        <ClinicalVisualization />
      </EditQuestionnaireContextProvider>
    </LargeContentBox>
  );
}
